import { Dispatch, MouseEventHandler, SetStateAction } from 'react';
import styled from 'styled-components';
import Draggable from 'react-draggable';

const StretchBar = styled.div`
  position: absolute;
  width: 100%;
  height: 4px;
  bottom: -2px;
  cursor: row-resize;
  z-index: ${({ theme }) => theme.zIndex.tooltip};
`;
type Props = {
  height: number;
  maxHeight: number;
  minHeight: number;
  onDrag: Dispatch<SetStateAction<number>>;
  onStop: () => void;
  onMouseEnter: MouseEventHandler<HTMLDivElement>;
  onMouseLeave: MouseEventHandler<HTMLDivElement>;
};

const ResizablePanelVertical = ({
  height,
  maxHeight,
  minHeight,
  onDrag,
  onStop,
  onMouseEnter,
  onMouseLeave,
}: Props) => (
  <Draggable
    axis="y"
    position={{ x: 0, y: (height > maxHeight ? maxHeight : height) * -1 }}
    onDrag={(e, { deltaY }) => onDrag(height + deltaY * -1)}
    onStop={onStop}
    bounds={{
      bottom: -1 * minHeight,
      top: -1 * maxHeight,
    }}
  >
    <StretchBar onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} />
  </Draggable>
);

export default ResizablePanelVertical;
